import React, { useState, useEffect, useCallback } from "react";
import styles from "./inventorySliderComponents.module.scss";
import { showErrorToast } from "../../assets/toastUtils";
import InventoryMultipleDatesRangesAndWeekDays from "./InventoryMultipleDatesRangesAndWeekDays";
import ToggleSwitch from "./Switch/ToggleSwitch";

const InventoryRatesUpdate = ({
  categories,
  currentDate,
  baseUrl,
  property_id,
  userToken,
  setLoader,
  channels,
  setShow,
}) => {
  // console.log("channels", channels);
  // const fetchInventoryData = async () => {
  //   if (activeApp === "pms") {
  //     fetchInfo(property_id?.id, uniqueChannelId);
  //   } else if (activeApp === "channel_manager") {
  //     fetchInfo(
  //       property_id?.id,
  //       viewType === "channel_view" ? room_id : channel_id,
  //       viewType
  //     );
  //   } else {
  //     return;
  //   }
  // };

  const [dates, setDates] = useState({ from_date: "", to_date: "" });
  const vendorToken = localStorage.getItem("token");
  const [days, setDays] = useState({});
  const [inventoryData, setInventoryData] = useState([]);

  const handleDaysChange = useCallback((data) => {
    setDays(data);
  }, []);

  const [dateRanges, setDateRanges] = useState([
    {
      id: 1,
      dates: { from_date: "", to_date: "" },
      days: {},
    },
  ]);

  const [mealPlans, seMealPlans] = useState([]);
  const [mealPlanId, setMealPlanId] = useState({});

  // const getMealPlans = async () => {
  //   try {
  //     const response = await fetch(
  //       `${baseUrl}/api/v1/mealPlans/${property_id.id}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${userToken}`,
  //         },
  //       }
  //     );

  //     const data = await response.json();
  //     seMealPlans(data.plans);
  //   } catch (error) {
  //     showErrorToast("failed to fetch meal plans");
  //   }
  // };

  // useEffect(() => {
  //   getMealPlans();
  // }, []);

  const handleCheckboxChange = async (event) => {
    const { value, checked } = event.target;
    const roomId = parseInt(value);

    if (checked) {
      if (!inventoryData.some((item) => item.room_id === roomId)) {
        try {
          const mealPlans = await fetchRatePlan(roomId);
          console.log(mealPlans, 'mealPlans');

          const newRoomData = {
            room_id: roomId,
            meal_plan_id: "",
            base_rate: "",
            extra_adult: "",
            extra_child_without_bed: "",
            extra_child_with_bed: "",
            mealPlans: mealPlans
          };

          setInventoryData((prev) => [...prev, newRoomData]);
        } catch (err) {
          console.error("Failed to fetch meal plans", err);
        }
      }
    } else {
      setInventoryData((prev) =>
        prev.filter((item) => item.room_id !== roomId)
      );
    }
  };

  const fetchRatePlan = async (roomId) => {
    if (!property_id || !roomId) return;

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${vendorToken}`);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/rate-plans/${property_id}/list/${roomId}`,
        requestOptions
      );
      const result = await response.json();
      const mealPlans = result?.data || [];
      return mealPlans;
    } catch (error) {
      console.error("Error fetching rate plan:", error);
    }
  };

  const handleInputChange = (event, roomId, key) => {
    const { value } = event.target;

    setInventoryData(
      inventoryData?.map((item) =>
        item.room_id === roomId
          ? { ...item, [key]: parseInt(value) || "" }
          : item
      )
    );
  };

  const [selectedChannel, setSelectedChannel] = useState([]);

  const handleCloseBookingSlider = () => {
    setShow(false);
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, [1000]);
  };

  // useEffect(() => {
  //   if (defaultSelectedChannel && defaultSelectedChannel.length > 0) {
  //     setSelectedChannel(defaultSelectedChannel);
  //   }
  // }, [defaultSelectedChannel]);

  const handleCheckboxChangeChannel = (event) => {
    const { value, checked } = event.target;
    const channel_id = value;
    const channel_name = event.target.dataset.name;

    setSelectedChannel((prevSelectedChannels) => {
      if (checked) {
        // Check if the channel is already selected
        const isAlreadySelected = prevSelectedChannels.some(
          (channel) => +channel.channel_id === +channel_id
        );

        if (!isAlreadySelected) {
          // If not already selected, add to the array
          return [...prevSelectedChannels, { channel_id, channel_name }];
        }
      } else {
        // If unchecked, remove from the array
        return prevSelectedChannels.filter(
          (channel) => +channel.channel_id !== +channel_id
        );
      }

      // If already selected and checked, return the current state without changes
      return prevSelectedChannels;
    });
  };

  const [restrictions, setRestrictions] = useState({
    restrictions: false, // changed from "" to false
    closedToArrival: false,
    closedToDeparture: false,
    minLOS: "",
    maxLOS: "",
    closed: false
  });

  const updateStayRestrictions = async () => {

    if (inventoryData.length === 0) {
      showErrorToast("Please add inventory data.");
      return;
    }

    for (const item of inventoryData) {
      if (
        item.base_rate === "" ||
        item.extra_adult === "" ||
        item.extra_child_with_bed === "" ||
        item.extra_child_without_bed === ""
      ) {
        showErrorToast(
          "Please fill in all fields for each room before submitting."
        );
        return;
      }
    }

    const postData = {
      multiple_updates: true,
      multiple_updates_array: dateRanges?.map((range) => ({
        from_date: range.dates.from_date,
        to_date: range.dates.to_date,
        rates_data: inventoryData,
        ...range.days,
      })),
    };

    // try {
    //   setLoader(true);

    //   const response = await fetch(
    //     `${baseUrl}/api/v1/update/rates/${property_id?.id}`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${userToken}`,
    //       },
    //       method: "POST",
    //       body: JSON.stringify(postData),
    //     }
    //   );

    //   const data = await response.json();
    //   if (data.success) {
    //     showSuccessToast(data.message);
    //     setShow(false);
    //     fetchInventoryData(
    //       property_id?.id,
    //       viewType === "channel_view" ? room_id : channel_id,
    //       viewType
    //     );
    //   } else {
    //     showErrorToast(data.message || "Failed to update stay restrictions.");
    //   }
    // } catch (error) {
    //   console.error("An error occurred:", error);
    //   showErrorToast("An error occurred while updating stay restrictions.");
    // } finally {
    //   setLoader(false);
    // }
  };

  const updateHotelRates = async () => {
    if (inventoryData.length === 0) {
      showErrorToast("Please add inventory data.");
      return;
    }

    for (const item of inventoryData) {
      if (
        item.base_rate === "" ||
        item.extra_adult === "" ||
        item.extra_child_with_bed === "" ||
        item.extra_child_without_bed === ""
      ) {
        showErrorToast(
          "Please fill in all fields for each room before submitting."
        );
        return;
      }
    }

    const headers = {
      // "X-Channel-Token": "PoGC1kGsepDYT7lQ4Azqmmou03oqFbHA    mmm",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${userToken}`,
      "Cookie": process.env.REACT_APP_COOKIE,
    };

    const formatDateRanges = dateRanges?.map((range) => {
      const base = {
        from: range.dates.from_date,
        to: range.dates.to_date
      };

      // Only include days if any keys exist
      if (Object.keys(range.days || {}).length > 0) {
        return {
          ...base,
          ...range.days
        };
      }

      return base;
    });

    const HotelRateAmountNotif = inventoryData?.map((item) => ({
      room_id: item.room_id,
      rateplans: [
        {
          room_rate_plan_id: item?.meal_plan_id,
          price: item?.base_rate,
          extra_adult: item?.extra_adult,
          child_w_bed: item?.extra_child_with_bed,
          child_wo_bed: item?.extra_child_without_bed,
          restrictions,
          dateRanges: formatDateRanges
        }
      ]
    }));

    const postData = {
      hotelCode: property_id,
      HotelRateAmountNotif: HotelRateAmountNotif,
    };

    const body = JSON.stringify(postData);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v2/channel-manager/rates/bulk/update`,
        {
          method: "POST",
          headers,
          body,
          redirect: "follow"
        }
      );

      const result = await response.json();
      console.log(result);
    } catch (error) {
      console.error("Error updating hotel rates:", error);
    }
  };

  const handleRestrictionsChange = (value, name) => {
    setRestrictions({
      ...restrictions,
      [name]: value,
    });
  };

  const handleCloseToArrivalDepartureChange = (value, name) => {
    setRestrictions((prevRestrictions) => ({
      ...prevRestrictions,
      [name]: value ? true : false,
    }));
  };

  const handleMinMaxLOSChange = (e) => {
    const { name, value } = e.target;
    setRestrictions((prevRestrictions) => ({
      ...prevRestrictions,
      [name]: +value,
    }));
  };

  return (
    <>
      <div className={styles.container}>
        {/* <div style={{ width: "100%" }}>
          <div style={{ paddingBottom: "5px" }}>Select Date Range</div>
          <SelectDateRange
            dataFromChild={(from_date, to_date) => {
              setDates({
                from_date: from_date,
                to_date: to_date,
              });
            }}
            minDate={new Date(propertyCurrentDate)}
          />
        </div>
        <hr />
        <div>
          <DaySelectionWeekDays onSaveDates={handleDaysChange} />
        </div> */}

        <InventoryMultipleDatesRangesAndWeekDays
          dateRanges={dateRanges}
          setDateRanges={setDateRanges}
        // propertyCurrentDate={propertyCurrentDate}
        />

        <hr />

        {/* <div>
          <div className={styles.headings}> Select Meal Plan</div>
          <div className="flex flex_gap_20">
            {mealPlans?.map((mealPlan) => (
              <span key={mealPlan.id}>
                <label
                  style={{ cursor: "pointer" }}
                  className="flex flex_gap_5"
                >
                  <input
                    type="radio"
                    name="mealPlan"
                    style={{ cursor: "pointer" }}
                    onChange={() => setMealPlanId(mealPlan.id)}
                  />

                  {mealPlan.meal_plan_type}
                </label>
              </span>
            ))}
          </div>
        </div> */}

        {/* <hr /> */}

        <div>
          <div className={styles.headings}>Select Room Categories</div>

          {/* <table className={styles.table}>
            <thead>
              <tr>
                <th>Room Name</th>
                <th>Room Rate</th>
                <th>Extra Adult</th>
                <th>Child (with bed)</th>
                <th>Child (without bed)</th>
              </tr>
            </thead>
            <tbody>
              {categories?.map((room) => {
                const inventoryItem = inventoryData.find(
                  (item) => item.room_id === room.roomId
                );

                return (
                  <tr key={room.roomId}>
                    <div className={styles.checkboxContainer}>
                      <input
                        type="checkbox"
                        name="update_type"
                        onChange={handleCheckboxChange}
                        value={room.roomId}
                        checked={!!inventoryItem}
                        style={{ marginRight: "10px" }}
                        id={room.name}
                      />
                      <label htmlFor={room.name}>{room.name}</label>
                    </div>
                    {inventoryItem ? (
                      <>
                        <td className={styles.checkbox_td}>
                          <input
                            type="number"
                            value={inventoryItem.base_rate}
                            onChange={(e) =>
                              handleInputChange(e, room.roomId, "base_rate")
                            }
                            placeholder="Room Rate"
                          />
                        </td>
                        <td className={styles.checkbox_td}>
                          <input
                            type="number"
                            value={inventoryItem.extra_adult}
                            onChange={(e) =>
                              handleInputChange(e, room.roomId, "extra_adult")
                            }
                            placeholder="Extra Adult"
                          />
                        </td>
                        <td className={styles.checkbox_td}>
                          <input
                            type="number"
                            value={inventoryItem.extra_child_with_bed}
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                room.roomId,
                                "extra_child_with_bed"
                              )
                            }
                            placeholder="Child (with bed)"
                          />
                        </td>
                        <td className={styles.checkbox_td}>
                          <input
                            type="number"
                            value={inventoryItem.extra_child_without_bed}
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                room.roomId,
                                "extra_child_without_bed"
                              )
                            }
                            placeholder="Child (without bed)"
                          />
                        </td>
                      </>
                    ) : (
                      <td colSpan={4} style={{ textAlign: "center" }}>
                        <span>Select the meal plan to enter rates</span>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table> */}

          <table className={styles.table}>
            <thead>
              <tr>
                <th>Room Name/Meal Plan</th>
                <th>Room Rate</th>
                <th>Extra Adult</th>
                <th>Child (with bed)</th>
                <th>Child (without bed)</th>
              </tr>
            </thead>

            {categories?.map((room) => {
              const inventoryItem = inventoryData.find(
                (item) => item.room_id === room.roomId
              );

              return (
                <React.Fragment key={room.roomId}>
                  {/* First row: Room name with checkbox */}
                  <tr>
                    <td colSpan={6}>
                      <div className={styles.checkboxContainer}>
                        <input
                          type="checkbox"
                          name="update_type"
                          onChange={handleCheckboxChange}
                          value={room.roomId}
                          checked={!!inventoryItem}
                          style={{ marginRight: "10px" }}
                          id={`room-${room.roomId}`}
                        />
                        <label htmlFor={`room-${room.roomId}`}>{room.name}</label>
                      </div>
                    </td>
                  </tr>

                  {inventoryItem && (
                    <tr>
                      <td className={styles.checkbox_td}>
                        <select
                          className="p-1 border rounded"
                          onChange={(e) =>
                            handleInputChange(e, room.roomId, "meal_plan_id")
                          }
                          value={inventoryItem.meal_plan_id || ""}
                        >
                          <option value="">Select Meal Plan</option>
                          {inventoryItem?.mealPlans?.map((mealPlan, index) => (
                            <option value={mealPlan.id} key={index}>{mealPlan.name}</option>
                          ))}
                        </select>
                      </td>
                      <td className={styles.checkbox_td}>
                        <input
                          type="number"
                          value={inventoryItem.base_rate}
                          onChange={(e) =>
                            handleInputChange(e, room.roomId, "base_rate")
                          }
                          placeholder="Room Rate"
                        />
                      </td>
                      <td className={styles.checkbox_td}>
                        <input
                          type="number"
                          value={inventoryItem.extra_adult}
                          onChange={(e) =>
                            handleInputChange(e, room.roomId, "extra_adult")
                          }
                          placeholder="Extra Adult"
                        />
                      </td>
                      <td className={styles.checkbox_td}>
                        <input
                          type="number"
                          value={inventoryItem.extra_child_with_bed}
                          onChange={(e) =>
                            handleInputChange(e, room.roomId, "extra_child_with_bed")
                          }
                          placeholder="Child (with bed)"
                        />
                      </td>
                      <td className={styles.checkbox_td}>
                        <input
                          type="number"
                          value={inventoryItem.extra_child_without_bed}
                          onChange={(e) =>
                            handleInputChange(e, room.roomId, "extra_child_without_bed")
                          }
                          placeholder="Child (without bed)"
                        />
                      </td>
                      <td></td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </table>
        </div>

        <hr />

        <div>
          <div
            className={`${styles.headings} flex align_items_center flex flex_gap_10`}
          >
            <label htmlFor="restrictions">Restrictions</label>
            <ToggleSwitch
              name="restrictions"
              isOn={restrictions.restrictions}
              size="medium"
              handleToggle={handleRestrictionsChange}
            />
          </div>

          {restrictions.restrictions ? (
            <>
              <div className="flex align_items_center justify_content_between">
                Min Los
                <input
                  type="number"
                  value={restrictions.minLOS}
                  className={styles.inputRoomData}
                  onChange={handleMinMaxLOSChange}
                  name="minLOS"
                  min="1"
                />
              </div>

              <div className="flex align_items_center justify_content_between mt-10">
                Max Los
                <input
                  type="number"
                  value={restrictions.maxLOS}
                  className={styles.inputRoomData}
                  name="maxLOS"
                  onChange={handleMinMaxLOSChange}
                />
              </div>

              <div className="flex align_items_center justify_content_between mt-10">
                Close to Arrival
                <ToggleSwitch
                  isOn={restrictions.closedToArrival}
                  name="closedToArrival"
                  size="small"
                  handleToggle={handleCloseToArrivalDepartureChange}
                />
              </div>

              <div className="flex align_items_center justify_content_between mt-10">
                Close to Departure
                <ToggleSwitch
                  isOn={restrictions.closedToDeparture}
                  name="closedToDeparture"
                  size="small"
                  handleToggle={handleCloseToArrivalDepartureChange}
                />
              </div>
              <div className="flex align_items_center justify_content_between mt-10">
                Closed
                <ToggleSwitch
                  isOn={restrictions.closed}
                  name="closed"
                  size="small"
                  handleToggle={handleCloseToArrivalDepartureChange}
                />
              </div>
            </>
          ) : (
            <p>No restrictions added</p>
          )}
        </div>
      </div>

      <div
        className={`flex align_items_center flex_gap_10 ${styles.buttonContainer}`}
      >
        {/* <BgThemeButton
          type="submit"
          onClick={updateStayRestrictions}
          children={"Update"}
        />

        <Button onClick={handleCloseBookingSlider}>Cancel</Button> */}

        <button
        disabled
          type="submit"
          style={{opacity: 0.5}}
          // className="vendor_common_property pointer"
          onClick={updateHotelRates}
        >Update
        </button>

        <button
          className="no_logout_btn"
          onClick={() => setShow(false)}>
          Cancel
        </button>
      </div>
    </>
  );
};

export default InventoryRatesUpdate;
